import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PickerContextProvider } from '../PickerContext';
import { Picker, PickerDropdown, CurrencyOptionsList } from '../Parts';
import { CurrencyPickerBtn } from './CurrencyPickerBtn';
export const CurrencyPicker = ({ mode }) => (_jsx(PickerContextProvider, Object.assign({ mode: mode }, { children: _jsxs(Picker, { children: [_jsx(CurrencyPickerBtn, {}), _jsxs(PickerDropdown, { children: [_jsx(CurrencyPickerBtn, {}), _jsx(CurrencyOptionsList, {})] })] }) })));
